"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const TargetPath_vue_1 = __importDefault(require("./TargetPath.vue"));
const moment_1 = __importDefault(require("moment"));
const trans_1 = require("@common/tsutils/trans");
const label_functions_1 = require("@becrop/components/Toolkit/Heatmap2/models/options/label_functions");
const lucide_vue_next_1 = require("lucide-vue-next");
let ActiveSampleVue = class ActiveSampleVue extends vue_property_decorator_1.Vue {
    get path() {
        return this.element.getPath();
    }
    get csvMetadata() {
        if (!this.heatmap.csv)
            return null;
        return this.heatmap.csv.fields.map(field => {
            return {
                name: field.name,
                type: field.type,
                value: this.element.sample.csvMetadata.getValue(field.id),
            };
        });
    }
    capitalize(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }
    formatDate(date) {
        if (!date)
            return '-';
        const mdate = (0, moment_1.default)(date);
        if (!mdate.isValid())
            return '-';
        const d = mdate.date();
        const m = this.capitalize(mdate.format('MMM').replace('.', '').toLowerCase());
        const y = mdate.year();
        return `${d}${m}${y}`;
    }
    transBoolean(x) {
        if (x === true)
            return (0, trans_1.trans)('heatmap.type_options.true');
        if (x === false)
            return (0, trans_1.trans)('heatmap.type_options.false');
        return (0, trans_1.trans)('heatmap.type_options.not_defined');
    }
    formatSoilTypeId(x) {
        return (0, label_functions_1.soil_type_label_fn)(x + '');
    }
    stringOrNull(x) {
        if (!x)
            return '-';
        return x;
    }
    numberOrNull(x) {
        if (x === null)
            return '-';
        return x;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActiveSampleVue.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActiveSampleVue.prototype, "element", void 0);
ActiveSampleVue = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TargetPath: TargetPath_vue_1.default,
            User: lucide_vue_next_1.User,
        }
    })
], ActiveSampleVue);
exports.default = ActiveSampleVue;
